module.exports = __webpack_public_path__ + "static/media/roni.7f65e18f.jpeg";